var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, Suspense } from 'react';
import { Grid } from '@material-ui/core';
import MainLayout from '../../layouts/MainLayout';
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import './index.scss';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import { getWidgetDetails, getWidgetDetailsSuccess } from '../../store/widget/actions';
import { widgetDetailsData, widgetDetailsError, isLoadingWidgetDetails } from '../../store/widget/reducer';
import { getMetrics } from '../../services/widget-service';
import RefreshIcon from '../../assets/icons/refresh_right.svg';
import * as Constant from "../../utils/Constant";
var LazyDatePickerPanel = React.lazy(function () { return import('./components/DatePickerPanel'); });
var DatePickerPanel = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyDatePickerPanel, __assign({}, props)));
};
var LazyFilterPanel = React.lazy(function () { return import('./components/FilterPanel'); });
var FilterPanel = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyFilterPanel, __assign({}, props)));
};
var Loading = function () { return React.createElement("div", null, "Loading..."); };
// const LazyWidgetTable = React.lazy(() => import('../../components/report-type/single-table/SingleTable'));
// const WidgetTable = (props: SingleTableProps) =>
//   <Suspense fallback={<Loading />}>
//     <LazyWidgetTable {...props} />
//   </Suspense>
var LazyChartDetails = React.lazy(function () { return import('./components/ChartDetails'); });
var ChartDetails = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyChartDetails, __assign({}, props)));
};
var WidgetDetails = function (props) {
    var widgetDetails = props.widgetDetails;
    var t = useTranslation().t;
    var _a = useState(), media = _a[0], setMedia = _a[1];
    var widgetCode = props.match.params.widgetCode;
    var _b = useState(), detailsParams = _b[0], setDetailsParams = _b[1];
    var _c = useState([]), metricList = _c[0], setMetricList = _c[1];
    var _d = useState([]), reportTypeList = _d[0], setReportTypeList = _d[1];
    var date = new Date();
    var _e = useState([
        {
            startDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30),
            endDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1),
            key: 'selection'
        }
    ]), duration = _e[0], setDuration = _e[1];
    useEffect(function () {
        getCurrentMedia();
        getMetricList();
        props.dispatch(getWidgetDetails(widgetCode));
        document.title = t("page.widget_details") + Constant.APP_NAME;
        return (function () {
            props.dispatch(getWidgetDetailsSuccess(null));
        });
    }, []);
    useEffect(function () {
        if (props.location.state) {
            var passedWidgetParams = props.location.state.widgetParams;
            var widgetParams = {
                media_id: props.location.state.mediaId,
                data_level: passedWidgetParams.deviceType.value,
                filter_params: {
                    metric_id: passedWidgetParams.metric.value
                },
                from_date: passedWidgetParams.startDate,
                to_date: passedWidgetParams.endDate,
            };
            setDetailsParams(widgetParams);
        }
    }, [props.location.state]);
    useEffect(function () {
    }, [detailsParams]);
    useEffect(function () {
        if (widgetDetails) {
            var reportTypes = widgetDetails.reportTypes;
            setReportTypeList(reportTypes);
        }
    }, [widgetDetails]);
    var getCurrentMedia = function () {
        var mediaJson = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MEDIA);
        if (mediaJson) {
            var currentMedia = JSON.parse(mediaJson);
            setMedia(currentMedia);
        }
    };
    var getMetricList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metrics, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMetrics()];
                case 1:
                    metrics = _a.sent();
                    setMetricList(metrics);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Error Metric", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateDuration = function (duration) {
        console.log('updateDuration:', duration);
        setDuration(duration);
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "widget-details-container" },
            React.createElement("div", { className: "top-page-section" },
                React.createElement("div", { className: "page-title" },
                    React.createElement("div", { className: "widget-details-title" }, t("widget_details.title")),
                    React.createElement("button", { type: "button", className: "btn-text-no-border btn-back-to-dashboard" },
                        React.createElement("a", { href: "#/dashboard" }, t('widget_details.back_to_dashboard')))),
                React.createElement("div", { className: "btn-reset" },
                    React.createElement("img", { src: RefreshIcon, alt: "ic-reset" }),
                    React.createElement("div", null, "\u30EA\u30BB\u30C3\u30C8"))),
            React.createElement(Grid, { className: "widget-details-content", container: true, spacing: 2 },
                React.createElement(Grid, { className: "widget-filter-panel", item: true, xs: 12, sm: 2 },
                    React.createElement(DatePickerPanel, { dateRange: duration, onUpdateDuration: function (value) { return updateDuration(value); } }),
                    React.createElement(FilterPanel, { media: media }),
                    React.createElement("div", { className: "btn-load-data" },
                        React.createElement("button", { className: "btn-pb-primary" }, t('common.load_data')))),
                React.createElement(Grid, { item: true, xs: 12, sm: 10 },
                    React.createElement("div", { className: "chart-wrapper" },
                        React.createElement(ChartDetails, { widget: widgetDetails, widgetCode: widgetCode, widgetParams: detailsParams, mediaId: media ? media.id : 0, metrics: metricList, isLoadingData: props.isLoadingWidgetDetails })))))));
};
function mapStateToProps(state) {
    return {
        widgetDetails: widgetDetailsData(state),
        isLoadingWidgetDetails: isLoadingWidgetDetails(state),
        widgetDetailsError: widgetDetailsError(state),
    };
}
export default connect(mapStateToProps)(WidgetDetails);
